module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 73
// module chunks = 0